import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IDeviceService } from '@intigral/domain/lib/application/services/DeviceService';
import { useQuery } from '@tanstack/react-query';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { SelectProfile } from '../components/ui/SelectProfile';
import legacyUser from '../helpers/user';
import * as user from '../utils/user';
import { buildLanguageRoute } from '../utils/languageRouteBuilder';
import { isGuestKidsEntryPath, isGuestUser } from '../config/guestMode';
import { setGuestKidsMode } from '../guest/session';

type SelectProfileScreenProps = {
    screenName: string;
    screenKey: string;
};

export const SelectProfileScreen: React.FC<SelectProfileScreenProps> = ({ screenName, screenKey }) => {
    const params = useParams();
    const location = useLocation();
    const langPrefix = params['lang'] === 'en' ? 'en' : '';
    const userInfo = user.getUserInfo();
    const isGuest = isGuestUser(userInfo);

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['user-profile', userInfo?.username],
        enabled: Boolean(userInfo?.username) && !isGuest,
        queryFn: async () => {
            const info = user.getUserInfo();
            const _devices = await container
                .resolve<IDeviceService>(DI.SERVICES.IDeviceService)
                .getDevices(info.username, info.apiKey, info.authToken, info.identityToken);
            const profileList = await legacyUser.initiatedUserProfiles();
            return { devices: _devices, profileList: profileList };
        },
    });

    if (isGuest && isGuestKidsEntryPath(location.pathname, location.search)) {
        setGuestKidsMode(true);
        return <Navigate to={buildLanguageRoute('/kids-home', langPrefix)} replace />;
    }

    if (isGuest) {
        return <Navigate to={buildLanguageRoute('/', langPrefix)} replace />;
    }

    if (isError) {
        return;
    }

    return (
        <>
            <SelectProfile data={data} />
        </>
    );
};

export default SelectProfileScreen;
